import { animate, AnimationBuilder, style } from '@angular/animations';
import { ElementRef, QueryList } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { ExerciseService } from 'app/shared/services/exercises.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { VideoDialogComponent } from '../../theme/components/videoDialog/videoDialog.component';
import { ActivatedRoute } from '@angular/router';
var ExComponent = (function () {
    function ExComponent(exerciseService, challengeService, dialog, translate, builder, activatedRoute) {
        var _this = this;
        this.exerciseService = exerciseService;
        this.challengeService = challengeService;
        this.dialog = dialog;
        this.translate = translate;
        this.builder = builder;
        this.activatedRoute = activatedRoute;
        this.mainCategories = [];
        this.selected = 'true';
        this.displaySalmagundiIndicator = false;
        this.completedSalmagundiExerciseIds = [];
        this.ngUnsubscribe = new Subject();
        this.displayCategories = true;
        this.refs = [];
        this.displayCategories = true;
        this.exerciseService.getAllExercises().then(function (exercises) { return (_this.exercises = exercises); });
        this.exerciseService.getMainCategories().then(function (categories) { return (_this.mainCategories = categories); });
        // Find out whether salmagundi bonus indicator should be displayed
        combineLatest(this.challengeService.displayedChallenge, this.challengeService.team, this.challengeService.teamUser)
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function (_a) {
            var challenge = _a[0], team = _a[1], user = _a[2];
            if (
            // If a challenge is currently running and the user is member of a team
            challenge &&
                moment(challenge.start).isBefore(moment()) &&
                moment(challenge.end).isAfter(moment()) &&
                user &&
                user.membershipStatus === 'member' &&
                team &&
                team.userGroups.members.length >= challenge.minimalTeamMembers) {
                _this.displaySalmagundiIndicator = true;
            }
            else {
                _this.displaySalmagundiIndicator = false;
            }
            if (user && user.bonuses && user.bonuses.salmagundi && user.bonuses.salmagundi.exerciseIDs) {
                _this.completedSalmagundiExerciseIds = user.bonuses.salmagundi.exerciseIDs;
            }
            else {
                _this.completedSalmagundiExerciseIds = [];
            }
        });
        // check for query params and set filter: only relevant for kids modules
        this.activatedRoute.queryParams.subscribe(function (params) {
            var categoryId = params['category'];
            if (categoryId) {
                _this.filterargs = categoryId;
                _this.displayCategories = false;
            }
        });
    }
    ExComponent.prototype.openVideoDialog = function (ex) {
        var dialogRef = this.dialog.open(VideoDialogComponent, {
            panelClass: 'app-video-dialog-container',
            // width: '60vw',
            maxWidth: '2600px',
            position: {
                top: '5vh',
            },
            data: { exercise: ex },
        });
        dialogRef
            .afterClosed()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function () {
            console.log('The dialog was closed');
        });
    };
    ExComponent.prototype.filter = function (cat) {
        this.filterargs = null;
        if (cat) {
            this.filterargs = cat._id;
        }
    };
    ExComponent.prototype.boxChanges = function (list) {
        var _this = this;
        if (list) {
            this.refs = [];
        }
        list.forEach(function (item) {
            _this.refs.push({
                el: item,
                rect: item.nativeElement.getBoundingClientRect(),
            });
        });
        this.requestedAnimation();
    };
    ExComponent.prototype.requestedAnimation = function () {
        var _this = this;
        requestAnimationFrame(function () {
            for (var _i = 0, _a = _this.refs; _i < _a.length; _i++) {
                var item = _a[_i];
                var domNode = item.el.nativeElement;
                var newBox = domNode.getBoundingClientRect();
                var oldBox = item.rect;
                var deltaX = oldBox.left - newBox.left;
                var deltaY = oldBox.top - newBox.top;
                // first build the animation
                var myAnimation = _this.builder.build([
                    style({ transform: "translate(" + deltaX + "px, " + deltaY + "px)" }),
                    animate('.2s ease-in-out', style({ transform: 'translate(0, 0)' })),
                ]);
                // then create a player from it
                var player = myAnimation.create(item.el.nativeElement);
                player.play();
            }
        });
    };
    /**
     * On destroy cancel active subscriptions
     */
    ExComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return ExComponent;
}());
export { ExComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/exercises/ex.component.ts.pre-build-optimizer.js